import { z } from 'zod';

export const legalTransactionRelationshipRealEstatePropertyTypeSchema =
  z.object({
    idPropertyType: z.number(),
    idRealEstate: z.number(),
  });

export type ILegalTransactionRelationshipRealEstatePropertyType = z.infer<
  typeof legalTransactionRelationshipRealEstatePropertyTypeSchema
>;
